<template>
  <div class="modal fade login" id="logIn_popup" tabindex="-1" role="dialog"
       aria-labelledby="" aria-hidden="true" data-backdrop="static"
       data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <button type="button" @click="closeModal()" class="close" data-dismiss="modal" aria-label="Close">
          <img src="static/img/millen_images/popup-close.svg" alt="">
        </button>
        <div class="modal-header">
          <h5 class="modal-title">Inloggen</h5>
          <h4>Vul hier je account gegevens in</h4>
        </div>
        <div class="modal-body">
          <form>
            <!-- MSISDN Input Field -->
            <div :class="{'form-group': true, 'error': !isValidMsisdn}">
              <input v-model="msisdn" type="tel" class="form-control" id="mobile" name="mobile"
                     placeholder="Je mobiele nummer" required/>
              <div v-if="!isValidMsisdn" class="error_msg">
                <label class="form-control-label" for="mobile"></label>
                Ongeldig mobiele nummer. Je mobiele nummer moet beginnen met 06 en bestaat uit 10
                cijfers. Of beginnend met 097 en bestaand uit 12 cijfers.
              </div>
            </div>

            <!-- Password Input Field -->
            <div :class="{'form-group': true, 'error': !isValidPassword}">
              <input v-model="password" type="password" class="form-control" id="pass" name="pass"
                     placeholder="Je wachtwoord" required/>
              <div v-if="!isValidPassword" class="error_msg">
                <label class="form-control-label" for="mobile"></label>
                Oeps, er ging iets fout. Probeer het later nog eens.
              </div>
            </div>
          </form>

          <!-- Login Links -->
          <div class="row justify-content-between login_links">
            <!--open forgot password popup-->
            <a v-on:click.prevent="goToForgotPassword()" href="">Wachtwoord vergeten?</a>
            <!--open register popup-->
            <a v-on:click.prevent="goToRegister()" href="">Meld je aan</a>
          </div>
        </div>

        <!-- Error Messages -->
        <div v-if="isOptedOut" class="error_msg">
          Je bent momenteel afgemeld voor Prepaid Surprise. Als je doorgaat word je automatisch
          weer aangemeld en ontvang je vanaf nu weer berichten en speelcodes van Prepaid Surprise.
        </div>
        <div v-if="!isCorrectPassword" class="error_msg">
          Je gebruikersnaam (mobiele nummer) en wachtwoord komen niet overeen. Probeer het nog eens.
        </div>
        <div v-if="internalError" class="error_msg">
          Oeps, er ging iets fout. Probeer het later nog eens.
        </div>
        <div v-if="this.getRegisterAsOptIn" class="error_msg">
          Je hebt al een My Surprise account. Om in te loggen klik hier.
        </div>

        <div class="modal-footer">
          <button type="button" @click.prevent="loginUser" class="black_btn">Inloggen</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import router from "../../router";
import gtm_analytics from "../../common/mixin/gtm_analytics";

export default {
  name: 'Login',
  mixins: [
    gtm_analytics
  ],
  data() {
    return {
      msisdn: null,
      password: null,
      isValidMsisdn: true,
      isValidPassword: true,
      isCorrectPassword: true,
      isOptedOut: false,
      loginAsOptOutAttempt: 0,
      internalError: false
    }
  },
  mounted() {
    $('#logIn_popup').modal('show')
    this.msisdn = (this.getRegisterAsOptIn) ? this.getMsisdn : null
    this.pushPopUp('Popup visit', 'Login Pop Up')
  },
  computed: {
    ...mapGetters([
      'getLoginResponse',
      'getCompareCustomerPasswordResponse',
      'getOptInResponse',
      'getRegisterAsOptIn',
      'getMsisdn'
    ])
  },
  methods: {
    ...mapMutations([
      'updateLoginModal',
      'updateMsisdn',
      'updateRedemptionMsisdn',
      'updatePassword',
      'updateAccessToken',
      'updateRegisterModal',
      'updateForgotPasswordModal',
      'updateRegisterAsOptIn'
    ]),
    ...mapActions([
      'accountLogin',
      'compareCustomerPassword',
      'optInCustomer',
      'updateMarketingConsent'
    ]),

    closeModal() {
      this.updateLoginModal(false)
    },

    resetValidityFlags() {
      this.isValidMsisdn = true
      this.isValidPassword = true
      this.isCorrectPassword = true
      this.isOptedOut = false
      this.updateRegisterAsOptIn(false)
      this.internalError = false
    },

    msisdnValidation() { return (/^(06[0-9]{8}|097[0-9]{9})$/.test(this.msisdn)) },

    passwordValidation() { return (/^.{8,}$/.test(this.password)) },

    validateForm() {
      if (!this.msisdnValidation() && !this.passwordValidation()) {
        this.isValidMsisdn = false
        this.isValidPassword = false
        return false
      } else if (!this.msisdnValidation()) {
        this.isValidMsisdn = false
        return false
      } else {
        if (!this.passwordValidation()) {
          this.isValidPassword = false
          return false
        }
      }
      return true
    },

    loginUser() {
      this.updateMsisdn(this.msisdn)
      this.updatePassword(this.password)
      this.resetValidityFlags()

      if (this.validateForm()) {
        this.compareCustomerPassword({
          msisdn: this.msisdn,
          password: this.password
        })
          .then(() => {
            if (this.getCompareCustomerPasswordResponse === null) {
              this.internalError = true
            } else {
              if (this.getCompareCustomerPasswordResponse.failReason === "NOT_EXISTS")
                this.isValidMsisdn = false

              if (this.getCompareCustomerPasswordResponse.failReason === "WRONG_PASSWORD")
                this.isCorrectPassword = false

              if (this.getCompareCustomerPasswordResponse.result === "SUCCESS") {
                if (this.loginAsOptOutAttempt === 1) {
                  this.handleLoginAsOptout()
                } else {
                  this.submitLogin()
                }
              }
            }
          })
      }
    },

    // Handle opted-out user login
    handleLoginAsOptout() {
      this.optInCustomer({ msisdn: this.msisdn })
        .then(() => {
          if (this.getOptInResponse === null) {
            this.internalError = true
          } else {
            this.submitLogin()
          }
        })
    },

    // Final login submission with marketing consent handling
    submitLogin() {
      this.accountLogin()
        .then(() => {
          if (this.getLoginResponse === null) {
            this.internalError = true
          } else {
            if (this.getLoginResponse.isUserLoggedIn === true) {
              this.handleMarketingConsentFromRegistration()
              this.updateAccessToken(this.getLoginResponse.encryptedKey)
              this.updateLoginModal(false)
              $('#logIn_popup').modal('hide')
              router.push({ name: 'Account' })
            } else {
              this.handleLoginResult()
            }
          }
        })
    },

    // Handle marketing consent for users redirected from registration
    handleMarketingConsentFromRegistration() {
      // Check if user came from registration and has marketing consent stored
      if (this.$store.state.registerMarketingConsentTemp &&
        this.$store.state.registerMarketingConsentTemp.msisdn === this.msisdn) {
        this.updateMarketingConsent({
          msisdn: this.msisdn
        })
          .catch((error) => {
            console.error('Error updating marketing consent from registration:', error)
          })
      }
      this.$store.commit('storeRegisterMarketingConsentTemp', null)
    },

    handleLoginResult() {
      if (this.getLoginResponse.failReason === 'OPTED_OUT') {
        this.isOptedOut = true
        this.loginAsOptOutAttempt = this.loginAsOptOutAttempt === 0 ? 1 : 0
      }
    },

    goToRegister() {
      $('#logIn_popup').modal('hide')
      this.updateLoginModal(false)
      this.updateRegisterModal(true)
    },

    goToForgotPassword() {
      $('#logIn_popup').modal('hide')
      this.updateLoginModal(false)
      this.updateForgotPasswordModal(true)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/Login.vue